import {
  MaterialReactTable,
  useMaterialReactTable,
} from "material-react-table";
import React from "react";
import { Box, Typography } from "@mui/material";
import { lightTable } from "../../../styles/muiProps";
import { SubTableCols } from "./cols";

export default function SubTable({ data, key }) {
  console.log("sub Data", data);
  const table = useMaterialReactTable({
    columns: SubTableCols,
    data,
    ...lightTable,
  });
  return (
    <Box sx={{ width: "100%" }} onClick={(e) => e.stopPropagation()}>
      <Typography sx={{ m: 1, mt: 0 }}>History Records:</Typography>

      <MaterialReactTable table={table} />
    </Box>
  );
}
